import { useEffect, useMemo, useRef } from "react";
import { useKeyPressTreeContext, } from "../../keyPressManagement/index.js";
import { useChildKeyPressTreeContextValue } from "./useChildKeyPressTreeContextValue.js";
export function useKeyPressTreeNode({ focused, onKeyPress, }) {
    const childKeyPressTreeNodeRef = useRef(undefined);
    const { registerActiveKeyPressTreeNode, unregisterActiveKeyPressTreeNode } = useKeyPressTreeContext();
    const listenerRef = useRef(undefined);
    useEffect(() => {
        listenerRef.current = onKeyPress;
        return () => {
            listenerRef.current = undefined;
        };
    }, [onKeyPress]);
    const keyPressTreeNode = useMemo(() => ({
        listenerRef,
        childKeyPressTreeNodeRef,
    }), []);
    useEffect(() => {
        if (focused && registerActiveKeyPressTreeNode) {
            registerActiveKeyPressTreeNode(keyPressTreeNode);
        }
        return () => {
            if (focused && unregisterActiveKeyPressTreeNode) {
                unregisterActiveKeyPressTreeNode(keyPressTreeNode);
            }
        };
    }, [focused, registerActiveKeyPressTreeNode, unregisterActiveKeyPressTreeNode, keyPressTreeNode]);
    return useChildKeyPressTreeContextValue(childKeyPressTreeNodeRef);
}
